<template>
    <div>
        <h1 class="mb-4 font-active">personalize your ring</h1>
        <p>
            Have a meaningful message to convey or a date to remember forever? Why not get it permanently inscribed on the inside of your engagement ring or wedding band! <br><br>
            Friendly Diamonds offers FREE engraving service for all make-to-order and custom-made rings. Our 'Create Your Own' engagement rings allow you to add a message to the ring on the 'Complete Your Ring' page. A few settings may not have an option for engraving due to the ring's design. Engravings can be an alphanumeric combination and ideally the length should not exceed 20 characters. For ring engraving ideas and inspirations, read our blog on <NuxtLink :to="localePath('/blog/wedding-band-ring-engraving')">ring engraving ideas</NuxtLink>. 
        </p>
        <h2>Returns, Resize, and Repairs of Engraved Rings</h2>
        <p>
            Due to their personalized characteristics, an amount of $50 is deducted from the refund or exchange value when returning or exchanging engraved rings. Depending on the increase or decrease in size of the ring, the engraved characters may look different from the original when resized and may become lighter, narrower, wider, or erased altogether. Repairs to engraved rings can change the look of the engraving depending on the nature of repair. In this case, the ring can be re-engraved for a small fee of $30. Please refer to our <NuxtLink :to="localePath('/customer-service/ring-resizing')">resizing policy</NuxtLink> for more information.
        </p>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
</script>

<style scoped>
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h3, h2{
        font-size: 18px;
    }
    p{
        font-size: 14px;
    }
    ul li {
        font-size: 14px;
    }
}
</style>